import React from 'react';
import { Container, Row, Col, Carousel, Button } from 'react-bootstrap';


function Interview() {
  return (
    <React.Fragment>
      <Container style={{ minHeight: '0px' }}>
        <Row>
          <Col className='text-center'>
            <h1 className="pb-5">Stimmen aus der Praxis</h1>
          </Col>
        </Row>
        <Row className="gx-lg-4 gx-xl-5 pb-0">
          <Col className="col-12 col-lg-6">
            <img 
              src={require('../../images/home/Interview_Bild.webp')}
              alt="Interview"
              className="img-fluid"
            />
          </Col>
          <Col className="col-12 col-lg-6">
            <blockquote className="rbs-quote">
              <p className="rbs-quote-text">
                Die vielen individuellen Redaktionsgespräche sind für uns der größte Mehrwert. Wir konnten Themen
                platzieren, die später in mehreren Fachmedien erschienen sind.
              </p>
              <p></p>
              <p className="rbs-quote-author">Teilnehmerin der Fachpressetage</p>
            </blockquote>
            
            <Button
              className="mt-4"
              href="https://www.rbsonline.de/blog/viel-zeit-fuer-individuelle-redaktionsgespraeche/"
              target="_blank"
              rel="noopener noreferrer"
              variant='rbs-button-orange rbs-action-buttons'
              size='lg'
            >
              Interview lesen
            </Button>
          </Col>

        </Row>
      </Container>
    </React.Fragment>
  )
}

export default Interview;